import {
  If,
  Maybe,
  PhoneNumberInput,
  VerticalID,
  Args,
  Operation,
} from '../../../__generated__/globalTypes'

import {
  VerifyPhoneNumberSuccessFragment,
  verifyPhoneNumberSuccessFragmentString,
} from '../../fragments/__generated__/VerifyPhoneNumberSuccessFragment'

import {
  VerifyPhoneNumberFailureFragment,
  verifyPhoneNumberFailureFragmentString,
} from '../../fragments/__generated__/VerifyPhoneNumberFailureFragment'

import { expenseReloadString } from '../../fragments/__generated__/ExpenseReload'

import { bankAccountFragmentString } from '../../fragments/__generated__/BankAccountFragment'

import { addressFragmentString } from '../../fragments/__generated__/AddressFragment'

import { planFeatureIconString } from '../../fragments/__generated__/PlanFeatureIcon'

import { featureFragmentString } from '../../fragments/__generated__/FeatureFragment'

import { storefrontString } from '../../fragments/__generated__/Storefront'

import { minimalSponsorFragmentString } from '../../fragments/__generated__/MinimalSponsorFragment'

import { stripeSubscriptionString } from '../../fragments/__generated__/StripeSubscription'

import { subscriptionMetadataString } from '../../fragments/__generated__/SubscriptionMetadata'

import { amountString } from '../../fragments/__generated__/Amount'

import { stripeSourceFragmentString } from '../../fragments/__generated__/StripeSourceFragment'

import { planFragmentString } from '../../fragments/__generated__/PlanFragment'

import { creditCardFragmentString } from '../../fragments/__generated__/CreditCardFragment'

import { subscriptionFeaturesString } from '../../fragments/__generated__/SubscriptionFeatures'

import { planFeatureFragmentString } from '../../fragments/__generated__/PlanFeatureFragment'

import { accountFragmentString } from '../../fragments/__generated__/AccountFragment'

import { userSettingsFragmentString } from '../../fragments/__generated__/UserSettingsFragment'

import verifyPhoneNumberRawString from '../VerifyPhoneNumber.graphql'

const verifyPhoneNumberString = [
  verifyPhoneNumberRawString,
  verifyPhoneNumberSuccessFragmentString,
  verifyPhoneNumberFailureFragmentString,
  expenseReloadString,
  bankAccountFragmentString,
  addressFragmentString,
  planFeatureIconString,
  featureFragmentString,
  storefrontString,
  minimalSponsorFragmentString,
  stripeSubscriptionString,
  subscriptionMetadataString,
  amountString,
  stripeSourceFragmentString,
  planFragmentString,
  creditCardFragmentString,
  subscriptionFeaturesString,
  planFeatureFragmentString,
  accountFragmentString,
  userSettingsFragmentString,
].join('\n\n')

export type VerifyPhoneNumberData = {
  verifyPhoneNumber: {
    __typename: 'VerifyPhoneNumberSuccess' | 'VerifyPhoneNumberFailure'
  } & (
    | If<'VerifyPhoneNumberSuccess', VerifyPhoneNumberSuccessFragment>
    | If<'VerifyPhoneNumberFailure', VerifyPhoneNumberFailureFragment>
  )
  createUserLoginLink: {
    link: Maybe<string>
  }
}

export type VerifyPhoneNumberVariables = {
  phoneNumber: PhoneNumberInput
  verificationCode: string
  sponsorGenealogyIdOrSlug?: Maybe<string>
  shouldNotCreateNewAccount?: Maybe<boolean>
  shouldReassignNumber?: Maybe<boolean>
  verticalId: VerticalID
  queryParams: Args
}

export type VerifyPhoneNumber = Operation<
  VerifyPhoneNumberData,
  VerifyPhoneNumberVariables
>

export const VerifyPhoneNumber = ({
  phoneNumber,
  verificationCode,
  sponsorGenealogyIdOrSlug,
  shouldNotCreateNewAccount,
  shouldReassignNumber,
  verticalId,
  queryParams,
}: VerifyPhoneNumberVariables): VerifyPhoneNumber => ({
  query: verifyPhoneNumberString,
  variables: {
    phoneNumber: PhoneNumberInput(phoneNumber),
    verificationCode,
    sponsorGenealogyIdOrSlug,
    shouldNotCreateNewAccount,
    shouldReassignNumber,
    verticalId,
    queryParams: Args(queryParams),
  },
})
